import Vue from 'vue';
import Router from 'vue-router';
import Main from './views/Main.vue';
import Index from './views/Index.vue';
import Msg from './views/Msg.vue';
import My from './views/My.vue';


Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  routes: [

    {
      path: '/',
      name: 'main',
      component: Main,
      children: [
        {
          path: "index",
          name: "index",
          component: Index
        },
        {
          path: "msg",
          name: "msg",
          component: Msg
        },
        {
          path: "me",
          name: "my",
          component: My
        },
        {
          path: "",
          component: Index
        }
      ]
    },
    
    
    {
      path: '/index2',
      name: 'index2',
      component: () => import('./views/Index2.vue'), //进入中(解决渠道商标识码)
    },
    
    {
      path: '/reg',
      name: 'reg',
      component: () => import('./views/Register.vue'), //注册
    },

    {
      path: '/author',
      name: 'author',
      component: () => import('./views/Author.vue'), //获取用户微信信息，openid
    },
    
    /* 聊天---开始 */
    {
      path: '/liaotian',
      name: 'chart',
      component: () => import('./views/Chat/Chart.vue'),
    },
    {
      path: '/chart_admin',
      name: 'chart_admin',
      component: () => import('./views/Chat/Chart_Admin.vue'),
    },
    {
      path: '/note',
      name: 'note',
      component: () => import('./views/Chat/Note.vue'),
    },
    {
      path: '/banned',
      name: 'banned',
      component: () => import('./views/Chat/Banned.vue'),
    },
    {
      path: '/chat_specification',
      name: 'chat_specification',
      component: () => import('./views/Chat/Chat_Specification.vue'), //文明聊天规范
    },
    /* 聊天---结束 */

    /* 我的资料---开始 */
    {
      path: '/my_info',
      name: 'my_info',
      component: () => import('./views/My_Info/My_Info.vue'),
    },
    {
      path: '/my_photo',
      name: 'my_photo',
      component: () => import('./views/My_Info/My_Photo.vue'),
    },
    {
      path: '/my_nickname',
      name: 'my_nickname',
      component: () => import('./views/My_Info/My_Nickname.vue'),
    },
    {
      path: '/my_tags',
      name: 'my_tags',
      component: () => import('./views/My_Info/My_Tags.vue'),
    },
    {
      path: '/my_bg',
      name: 'my_bg',
      component: () => import('./views/My_Info/My_Bg.vue'),
    },
    {
      path: '/my_hide',
      name: 'my_hide',
      component: () => import('./views/My_Info/My_Hide.vue'),
    },
    {
      path: '/myloc',
      name: 'myloc',
      component: () => import('./views/My_Info/My_Info_Loc.vue'),
    },
    {
      path: '/hiding_list',
      name: 'hiding_list',
      component: () => import('./views/My_Info/Hiding_List.vue'),
    },
    /* 我的资料---结束 */

    /* 我的钱包---开始 */
    {
      path: '/tx2',
      name: 'tx2',
      component: () => import('./views/Purse/Tx.vue'),
    },
    {
      path: '/tx_mny',
      name: 'tx_mny',
      component: () => import('./views/Purse/Tx_Mny.vue'),
    },
    {
      path: '/scoredtl',
      name: 'scoredtl',
      component: () => import('./views/Purse/My_Score_Dtl.vue'),
    },
    {
      path: '/mkmny',
      name: 'mkmny',
      component: () => import('./views/Purse/My_Purse_MakeMoney.vue'),
    },
    {
      path: '/scorenote',
      name: 'scorenote',
      component: () => import('./views/Purse/Score_Note.vue'),
    },
    {
      path: '/txrecord',
      name: 'txrecord',
      component: () => import('./views/Purse/My_Tx_Record.vue'),
    },
    {
      path: '/evaluate',
      name: 'evaluate',
      component: () => import('./views/Purse/Evaluate.vue'),
    },
    {
      path: '/master',
      name: 'master',
      component: () => import('./views/Purse/From_Master.vue'),
    },
    {
      path: '/pupil',
      name: 'pupil',
      component: () => import('./views/Purse/Pupil.vue'),
    },
    {
      path: '/s_pupil',
      name: 's_pupil',
      component: () => import('./views/Purse/S_Pupil.vue'),
    },
    {
      path: '/gift_gouSu2',
      name: 'gift_gouSu2',
      component: () => import('./views/Purse/Gift_TouSu2.vue'),
    },
    {
      path: '/gift_touSu2_dtl',
      name: 'gift_touSu2_dtl',
      component: () => import('./views/Purse/Gift_TouSu2_Dtl.vue'),
    },
    {
      path: '/relieve',
      name: 'relieve',
      component: () => import('./views/Purse/Relieve.vue'), //解绑
    },
    {
      path: '/scorerules',
      name: 'scorerules',
      component: () => import('./views/Purse/Score_Rules.vue'),
    },
    /* 我的钱包---结束 */

    /* 金币---开始 */
    {
      path: '/mycoin',
      name: 'mycoin',
      component: () => import('./views/Coin/My_Coin.vue'),
    },
    {
      path: '/coindtl',
      name: 'coindtl',
      component: () => import('./views/Coin/My_Coin_Dtl.vue'),
    },
    
    /* 金币---结束 */

    /* 投诉举报---开始 */
    {
      path: '/complain',
      name: 'complain',
      component: () => import('./views/Complain/Complain.vue'),
    },
    {
      path: '/complain_history',
      name: 'complain_history',
      component: () => import('./views/Complain/Complain_History.vue'),
    },
    {
      path: '/gift_tousu',
      name: 'gift_tousu',
      component: () => import('./views/Complain/Gift_TouSu.vue'),
    },
    {
      path: '/gift_touSu_dtl',
      name: 'gift_touSu_dtl',
      component: () => import('./views/Complain/Gift_TouSu_Dtl.vue'),
    },
    
    {
      path: '/complaint_details',
      name: 'complaint_details',
      component: () => import('./views/Complain/Complaint_Details.vue'),
    },
    /* 投诉举报---结束 */

    /* 系统设置---开始 */
    {
      path: '/sys_set',
      name: 'sys_set',
      component: () => import('./views/System/Sys_Set.vue'),
    },
    {
      path: '/dark_model',
      name: 'dark_model',
      component: () => import('./views/System/DarkModel.vue'),
    },
    {
      path: '/wxnotice',
      name: 'wxnotice',
      component: () => import('./views/System/WxNotice.vue'),
    },
    {
      path: '/rz',
      name: 'rz',
      component: () => import('./views/System/User_Author.vue'),
    },
    {
      path: '/wechat',
      name: 'wechat',
      component: () => import('./views/System/Bind_WeChat.vue'),
    },
    {
      path: '/safe',
      name: 'safe',
      component: () => import('./views/System/Safe_Center.vue'),
    },
    {
      path: '/qst',
      name: 'qst',
      component: () => import('./views/System/Question.vue'),
    },
    {
      path: '/dark_room',
      name: 'dark_room',
      component: () => import('./views/System/Dark_Room.vue'), //小黑屋
    },
    {
      path: '/charge',
      name: 'charge',
      component: () => import('./views/System/Charge.vue'), //收费设置
    },
    {
      path: '/admin_voice',
      name: 'admin_voice',
      component: () => import('./views/System/Admin_Voice.vue'), //收费设置
    },
    /* 系统设置---结束 */

    /* 注册引导---开始 */
    {
      path: '/reg_sex',
      name: 'reg_sex',
      component: () => import('./views/Register/Reg_selectSex.vue'),
    },
    {
      path: '/reg_age',
      name: 'reg_age',
      component: () => import('./views/Register/Reg_selectAge.vue'),
    },
    {
      path: '/reg_photo',
      name: 'reg_photo',
      component: () => import('./views/Register/Reg_selectPhoto.vue'),
    },
    {
      path: '/user_agreement',
      name: 'user_agreement',
      component: () => import('./views/Register/User_Agreement.vue'), //小火柴用户协议
    },
    {
      path: '/reg_wxgz',
      name: 'reg_wxgz',
      component: () => import('./views/Register/Reg_wxgz.vue'), //邀请新用户引导关注公众号
    },
    /* 注册引导---结束 */

    /* 陪玩---开始 */
    {
      path: '/play_apply1',
      name: 'play_apply1',
      component: () => import('./views/Accompany/Play_Apply1.vue'),
    },
    {
      path: '/play_apply2',
      name: 'play_apply2',
      component: () => import('./views/Accompany/Play_Apply2.vue'),
    },
    {
      path: '/play_apply3',
      name: 'play_apply3',
      component: () => import('./views/Accompany/Play_Apply3.vue'),
    },
    {
      path: '/play_apply4',
      name: 'play_apply4',
      component: () => import('./views/Accompany/Play_Apply4.vue'),
    },
    {
      path: '/play_apply5',
      name: 'play_apply5',
      component: () => import('./views/Accompany/Play_Apply5.vue'),
    },
    {
      path: '/play_list',
      name: 'play_list',
      component: () => import('./views/Accompany/Play_List.vue'),
    },
    {
      path: '/play_dtl',
      name: 'play_dtl',
      component: () => import('./views/Accompany/Play_Dtl.vue'),
    },
    {
      path: '/play_comment',
      name: 'play_comment',
      component: () => import('./views/Accompany/Play_Comment.vue'),
    },
    {
      path: '/play_order',
      name: 'play_order',
      component: () => import('./views/Accompany/Play_Order.vue'),
    },
    {
      path: '/play_order_list',
      name: 'play_order_list',
      component: () => import('./views/Accompany/Play_Order_List.vue'),
    },
    {
      path: '/play_appraise',
      name: 'play_appraise',
      component: () => import('./views/Accompany/Play_Appraise.vue'),
    },
    {
      path: '/play_check',
      name: 'play_check',
      component: () => import('./views/Accompany/Play_Check.vue'),
    },
    /* 陪玩---结束 */

    /* 相册---开始 */
    {
      path: '/photo_album',
      name: 'photo_album',
      component: () => import('./views/Album/Photo_Album.vue'), //相册
    },
    {
      path: '/photo_album_detail',
      name: 'photo_album_detail',
      component: () => import('./views/Album/Photo_Album_detail.vue'), 
    },
    /* 相册---结束 */
    
    {
      path: '/vip_center',
      name: 'vip_center',
      component: () => import('./views/Vip_Center.vue'), // 会员中心
    },
    

    {
      path: '/recently_online',
      name: 'recently_online',
      component: () => import('./views/Recently_Online.vue'), //最近在线
    },
    {
      path: '/friend',
      name: 'friend',
      component: () => import('./views/My_Friends.vue'), //我的好友
    },

    {
      path: '/my_gift',
      name: 'my_gift',
      component: () => import('./views/My_Gift.vue'), //礼物墙
    },

    {
      path: '/rank',
      name: 'rank',
      component: () => import('./views/Rank.vue'), //排行榜
    },

    {
      path: '/my_topic',
      name: 'my_topic',
      component: () => import('./views/My_Topic.vue'), //个人主页
    },
    
    {
      path: '/sign',
      name: 'sign',
      component: () => import('./components/Sign.vue'), //签到
    },

    {
      path: '/popup',
      name: 'popup',
      component: () => import('./components/Popup.vue'), //匹配动画
    },
    
    {
      path: '/cancel',
      name: 'cancel',
      component: () => import('./views/Cancel.vue'), //账号注销
    },
    
    {
      path: '/geren_zhuye',
      name: 'home_page',
      component: () => import('./views/Home_Page.vue'), //主页
    },
    
    {
      path: '/lucky',
      name: 'lucky',
      component: () => import('./views/Lucky.vue'), //抽奖
    },
    
    {
      path: '/xunrenqu',
      name: 'look_people',
      component: () => import('./views/People_Search/Look_People.vue'), //寻人区
    },

    {
      path: '/release',
      name: 'release',
      component: () => import('./views/People_Search/Release.vue'), //寻人区-发布
    },
    
    {
      path: '/guidebook',
      name: 'guidebook',
      component: () => import('./views/Guidebook.vue'), //新手指南
    },
    
    {
      path: '/hello_boy',
      name: 'hello_boy',
      component: () => import('./views/Hello_Boy.vue'), //赚积分
    },

    {
      path: '/hello_girl',
      name: 'hello_girl',
      component: () => import('./views/Hello_Girl.vue'), //赚金币
    },

    {
      path: '/task_score',
      name: 'task_score',
      component: () => import('./views/Task_Score.vue'),//女生每日任务
    },

    {
      path: '/task_coin',
      name: 'task_coin',
      component: () => import('./views/Task_Coin.vue'), //男生每日任务
    },

    /* 请好友---开始 */
    {
      path: '/invite',
      name: 'invite',
      component: () => import('./views/Invite_Friends/Index.vue'), 
    },

    {
      path: '/invite_friends',
      name: 'invite_friends',
      component: () => import('./views/Invite_Friends/Invitation_Friend.vue'), 
    },

    {
      path: '/invite_profit',
      name: 'invite_profit',
      component: () => import('./views/Invite_Friends/Invite_Profit.vue'), 
    },
    /* 请好友---结束 */
  ],
});


router.beforeEach((to, from, next) => {
  if(!window.entryUrl){
    window.entryUrl = window.location.href.split('#')[0];
  }
   
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {/* 微信环境 ------------------- start ---------------- */
      var wx_openid = ''
      if ($cookies.isKey('openid')) {
        wx_openid = $cookies.get('openid');
      }

      //1、优先处理分站参数问题
      if (to.path === '/index2') {
          next();
      } 
      else {
        //2、再处理微信重定问题
        if (wx_openid == '') {
          if (to.path === '/author') {
            next();
          }
          else {
            next('/author');
          }
        }
        else {
          next();
        }
      }
    } /* ----------------------------------------------      微信环境 ------------------- end  ---------------- */
    else {
      //非微信环境
      next();
    }
  
});

export default router;
